import React from 'react';
import { useSelector } from 'react-redux';
import ComponentVariantEditor from 'layout/organisms/ComponentVariantEditor';
import { selectVariantById } from 'store/componentDetailsSlice';
import { selectModalByName } from 'store/layoutSlice';
function VariantEdit() {
    var _a, _b;
    const componentDetails = useSelector((state) => state.componentDetails);
    const variantId = (_a = useSelector(selectModalByName('variantEdit'))) === null || _a === void 0 ? void 0 : _a.id;
    const variant = variantId
        ? useSelector((state) => selectVariantById(state.componentDetails, variantId))
        : null;
    return (React.createElement(ComponentVariantEditor, { type: "edit", data: Object.assign({ componentDetails, productId: (_b = componentDetails === null || componentDetails === void 0 ? void 0 : componentDetails.item) === null || _b === void 0 ? void 0 : _b.id }, variant) }));
}
export default VariantEdit;
